import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import EditCategoryModal from 'modules/budget/components/category/modals/edit-category-modal';
import { ParentCategory, Subcategory } from 'store/categoryStore';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class EditButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({modalOpen: true});
    }

    closeModal() {
        this.setState({modalOpen: false});
    }

    render() {
        const modal = this.state.modalOpen
            ? <EditCategoryModal
                onClose={this.closeModal}
                category={this.props.category}
                parentCategory={this.props.category.parent} />
            : null;

        return (
            <Fragment>
                <button onClick={this.openModal} className="btn btn-default">
                    <FontAwesomeIcon icon={faPen} className="edit-pen" fixedWidth={true} />
                </button>
                {modal}
            </Fragment>
        )
    }
}

EditButton.propTypes = {
    category: PropTypes.oneOfType([
        PropTypes.instanceOf(ParentCategory),
        PropTypes.instanceOf(Subcategory),
    ]).isRequired,
};

export default EditButton;



// WEBPACK FOOTER //
// ./src/modules/budget/components/category/category-table/edit-button.js